/* ============================================================
   PROJETO LAR 3D — theme.js
   Interações globais: menu mobile, ticker, quantidade, carrinho AJAX
   ============================================================ */
(function () {
  'use strict';

  /* ── Menu mobile ── */
  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () {
      toggle.classList.toggle('open');
      menu.classList.toggle('open');
    });
  }

  /* ── Steppers de quantidade ── */
  function initQty() {
    document.querySelectorAll('.qty-stepper').forEach(function (s) {
      var input = s.querySelector('input');
      var btns = s.querySelectorAll('button');
      if (!input || btns.length < 2) return;
      btns[0].addEventListener('click', function () {
        input.value = Math.max(parseInt(input.min || 1, 10), parseInt(input.value, 10) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      btns[1].addEventListener('click', function () {
        input.value = parseInt(input.value, 10) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ── Seletor de opções (PDP) ── */
  function initSwatches() {
    document.querySelectorAll('.pdp-swatches').forEach(function (group) {
      group.addEventListener('click', function (e) {
        if (!e.target.classList.contains('pdp-swatch')) return;
        group.querySelectorAll('.pdp-swatch').forEach(function (b) { b.classList.remove('active'); });
        e.target.classList.add('active');
      });
    });
  }

  /* ── Adicionar ao carrinho via AJAX ── */
  function initAddToCart() {
    document.querySelectorAll('[data-add-to-cart]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // Se houver arquivos anexados, envia nativamente (a API AJAX do carrinho
        // não transporta uploads — exige POST multipart/form-data normal).
        var fileInputs = form.querySelectorAll('input[type="file"]');
        for (var f = 0; f < fileInputs.length; f++) {
          if (fileInputs[f].files && fileInputs[f].files.length) return;
        }
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.dataset.loading = 'true'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(serializeForm(form))
        })
          .then(function (r) { return r.json(); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            if (btn) { btn.disabled = false; btn.dataset.loading = 'false'; }
            window.location.href = window.routes ? window.routes.cart_url : '/cart';
          })
          .catch(function () { if (btn) { btn.disabled = false; btn.dataset.loading = 'false'; } });
      });
    });
  }

  function serializeForm(form) {
    var data = new FormData(form);
    var obj = { items: [{ id: data.get('id'), quantity: parseInt(data.get('quantity') || 1, 10), properties: {} }] };
    data.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && value) obj.items[0].properties[m[1]] = value;
    });
    return obj;
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = el.dataset.cartLabel
        ? el.dataset.cartLabel.replace('{count}', count)
        : count;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initQty();
    initSwatches();
    initAddToCart();
  });
})();
